export default "__VITE_ASSET__Muy2hOTP__"